import { ConfirmationDialogAction, ConfirmationDialogResult } from '@/core/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'revoke-reason-anfrage-dialog',
  templateUrl: './revoke-reason-anfrage-dialog.component.html',
  styleUrls: ['./revoke-reason-anfrage-dialog.component.scss']
})
export class RevokeReasonAnfrageDialogComponent extends DialogContentBase {

  public formGroup: FormGroup;

  constructor(dialog: DialogRef) { 
    super(dialog);

    this.formGroup = new FormGroup({
      reason: new FormControl('', Validators.required)
    });
  }

  public onCancelClick() {
    let result: RevokeReasonAnfrageDialogResult = new RevokeReasonAnfrageDialogResult();

    result.action = ConfirmationDialogAction.Cancel;

    this.dialog.close(result);
  }

  public onSubmitClick() {
    let result: RevokeReasonAnfrageDialogResult = new RevokeReasonAnfrageDialogResult();

    result.action = ConfirmationDialogAction.Confirm;
    result.reason = this.formGroup.get('reason')?.value ?? "";

    this.dialog.close(result);
  }
}

export class RevokeReasonAnfrageDialogResult extends ConfirmationDialogResult {
  public reason: string;
}
